export default "__VITE_ASSET__FTGA1dhU__"